export const navItems = [
  { name: 'Home', href: '/' },
  { name: 'Solutions', href: '/solutions' },
  { name: 'Products', href: '/products' },
  { name: 'Capital Request', href: '/capital-request' },
  { name: 'Contact', href: '/contact' }
]
